import { ref } from '@nuxtjs/composition-api';
import { useStoryblok } from './useStoryblok';

export function useFetchBlogPage(pageSlug) {
  const { storyblok } = useStoryblok();
  const page = ref();

  async function fetchPage() {
    page.value = await storyblok.getPage(pageSlug);
  }

  return {
    fetchPage,
    page,
  };
}
